import { Box, Typography } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  expanded: boolean;
  onToggle: () => void;
  showMoreLabel?: string;
  showLessLabel?: string;
}

export const ShowMoreToggle: FC<Props> = ({ expanded, onToggle, showMoreLabel, showLessLabel }) => {
  const { t } = useTranslation();

  return (
    <Box
      onClick={onToggle}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        color: 'text.secondary',
        gap: 0.5,
        '&:hover': { color: 'text.primary' },
      }}
    >
      {expanded ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
      <Typography variant="body2">{expanded ? (showLessLabel ?? t('common.showLess')) : (showMoreLabel ?? t('common.showMore'))}</Typography>
    </Box>
  );
};
